import { forwardRef, useState } from "react";
import { Box, IconButton, Input, type InputProps } from "@chakra-ui/react";

export const PasswordInput = forwardRef<HTMLInputElement, InputProps>(
  (props, ref) => {
    const [visible, setVisible] = useState(false);
    return (
      <Box position="relative" width="full">
        <Input {...props} ref={ref} type={visible ? "text" : "password"} paddingEnd="12" />
        <IconButton
          type="button"
          aria-label={visible ? "Hide password" : "Show password"}
          aria-controls={props.id}
          disabled={props.disabled}
          variant="ghost"
          size="sm"
          position="absolute"
          insetEnd="1"
          top="50%"
          transform="translateY(-50%)"
          onMouseDown={(event) => event.preventDefault()}
          onClick={() => setVisible((value) => !value)}
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12Z" /><circle cx="12" cy="12" r="3" />{visible ? <path d="m3 3 18 18" /> : null}</svg>
        </IconButton>
      </Box>
    );
  }
);
PasswordInput.displayName = "PasswordInput";
